import type { ChatMessage } from '@goblic/shared'

/** Complete answers beat delayed streaming deltas; otherwise newest version wins. */
export function mergeChatMessages(...sources: ChatMessage[][]): ChatMessage[] {
  const byId = new Map<string, ChatMessage>()
  for (const messages of sources) for (const message of messages) {
    const old = byId.get(message.id)
    const streaming = message.payload.streaming === true
    const oldStreaming = old?.payload.streaming === true
    if (!old || (streaming !== oldStreaming ? !streaming : Date.parse(message.updatedAt) >= Date.parse(old.updatedAt))) {
      byId.set(message.id, message)
    }
  }
  return [...byId.values()].sort((a, b) => a.seq === b.seq ? 0 : BigInt(a.seq) < BigInt(b.seq) ? -1 : 1)
}
